'use client';

import React, { useState, useMemo } from 'react';
import { Box, Fade, Typography, Paper } from '@mui/material';
import { AgGridReact } from 'ag-grid-react';
import { useEstimator } from '../../context/EstimatorContext';

const ProjectBudgetSummary = ({ onComplete }) => {
  const { formData, setFormData } = useEstimator();

  const initialGridData = useMemo(
    () => [
      { account: '141-01-1001', description: 'ROW Lease Fees', totalPrice: '$' },
      { account: '141-01-1003', description: 'ROW Agent Fees', totalPrice: '$' },
      { account: '141-01-1004', description: 'Preliminary Survey', totalPrice: '$' },
      { account: '141-01-1007', description: 'Misc Permits and Fees', totalPrice: '$' },
      { description: 'Survey, Title, ROW Total', isSummary: true },
      { account: '141-01-2001', description: 'Line Pipe', totalPrice: '$' },
      { account: '141-01-2002', description: 'Segmentable Elbows', totalPrice: '$' },
      { account: '141-01-2023', description: 'Flow/Pressure Control', totalPrice: '$' },
      { account: '141-01-2041', description: 'Pipeline Markers', totalPrice: '$' },
      { account: '141-01-2052', description: 'Freight', totalPrice: '$' },
      { description: 'Materials Total', isSummary: true },
      { account: '141-01-3003', description: 'Mainline Lay Price', totalPrice: '$' },
      { account: '141-01-3013', description: 'NDE', totalPrice: '$' },
      { account: '141-01-3013', description: 'Chemical Treatment', totalPrice: '$' },
      { account: '141-01-4006', description: 'Engineering Services', totalPrice: '$' },
      { account: '141-01-4007', description: 'Engineering Services', totalPrice: '$' },
      { description: 'Construction Total', isSummary: true },
      { account: '141-01-4001', description: 'Inspection Services', totalPrice: '$' },
      { account: '141-01-4002', description: 'Environmental Services', totalPrice: '$' },
      { account: '141-01-4003', description: 'Environmental Services', totalPrice: '$' },
      { account: '141-01-4004', description: 'Environmental Services', totalPrice: '$' },
      { account: '141-01-5001', description: 'Environmental Services', totalPrice: '$' },
      { account: '141-01-6002', description: 'Legal Fees Services', totalPrice: '$' },
      { account: '141-01-6009', description: 'Legal Fees Services', totalPrice: '$' },
      { description: 'Project Management Total', isSummary: true },
      { description: 'Legal Fees Services', totalPrice: '$' },
      { description: 'Legal Fees Services', totalPrice: '$' },
    ],
    []
  );

  const [gridData, setGridData] = useState(initialGridData);

  const columnDefs = useMemo(
    () => [
      { headerName: 'Code', field: 'account', flex: 1, cellStyle: { fontWeight: 500, fontSize: '14px' } },
      { headerName: 'Description', field: 'description', flex: 2, cellStyle: { fontSize: '14px' } },
      { headerName: 'Cost Estimate', field: 'totalPrice', editable: true, flex: 1, cellStyle: { fontSize: '14px' } },
    ],
    []
  );

  return (
    <Fade in={true}>
      <Paper
        elevation={4}
        sx={{
          borderRadius: 3,
          overflow: 'hidden',
          p: 0,
          backgroundColor: '#f9f9f9',
          border: '1px solid #e0e0e0',
        }}
      >
        {/* Title */}
        <Box
          sx={{
            backgroundColor: '#223A64',
            py: 2,
            textAlign: 'center',
          }}
        >
          <Typography variant="h6" sx={{ color: 'white', fontWeight: 'bold', fontSize: '18px' }}>
            Project Budget
          </Typography>
        </Box>

        {/* Table */}
        <Box
          className="ag-theme-alpine"
          sx={{
            width: '100%',
            '& .ag-root-wrapper': { border: 'none' },
            '& .ag-header': { display: 'none' },
            '& .ag-row': { borderBottom: '1px solid #eee' },
            '& .ag-cell': { display: 'flex', alignItems: 'center' },
          }}
        >
          <AgGridReact
            rowData={gridData}
            columnDefs={columnDefs}
            defaultColDef={{
              resizable: true,
              sortable: false,
              filter: false,
            }}
            domLayout="autoHeight"
            suppressMenuHide
            suppressCellFocus
            suppressMovableColumns
            suppressColumnVirtualisation
            getRowStyle={(params) => {
              if (params.data?.isSummary) {
                return {
                  backgroundColor: '#e3f2fd',
                  fontWeight: 'bold',
                  fontSize: '14px',
                  color: '#1e88e5',
                  borderTop: '2px solid #90caf9',
                  borderBottom: '2px solid #90caf9',
                };
              }
              return {
                fontSize: '14px',
                lineHeight: '1.2',
                padding: '2px 4px',
              };
            }}
          />
        </Box>
      </Paper>
    </Fade>
  );
};

export default ProjectBudgetSummary;
